import React from "react";
import Badge from "@/components/ui/badge";
import {
  EntityType,
  entityTypeToEntityName
} from "@/services/hooks/entities/useEntityType";
import IconContainer from "@/components/ui/icon-container";

interface Props {
  entityType: EntityType;
  entityName: string;
  entityId: string;
  icon: JSX.Element | undefined;
}

const EntityBadge: React.FC<Props> = ({
  entityType,
  entityName,
  entityId,
  icon
}) => (
  <Badge
    onClick={(e) => {
      e.stopPropagation();
      window.open(
        `/${entityTypeToEntityName[entityType]}/${entityId}`,
        "_blank"
      );
    }}
    text={entityName}
    textVariant="smBodySecondary"
    textClassName="overflow-hidden text-ellipsis whitespace-nowrap"
    className="cursor-pointer max-w-52 truncate items-start justify-start transition-colors duration-200 px-[6px] py-1 hover:bg-white-8"
    icon={
      icon ? (
        <IconContainer className="!size-[18px]" color="secondary">
          {icon}
        </IconContainer>
      ) : undefined
    }
  />
);

export default EntityBadge;
